import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ViewStudentsViewItem } from 'edu-application/dist/students/view-students/view-students.viewmodel';
import { SuspendStudentRequest } from 'edu-application/dist/students/suspend-student/suspend-student.request';
import { SuspendStudentViewModel } from 'edu-application/dist/students/suspend-student/suspend-student.viewmodel';
import { TransferStudentRequest } from 'edu-application/dist/students/transfer-student/transfer-student.request';
import { TransferStudentViewmodel } from 'edu-application/dist/students/transfer-student/transfer-student.viewmodel';
import { environment } from 'src/environments/environment';
import { LoginService } from '../login/login.service';
import { StudentOverviewModel, StudentsOnboardingViewmodel } from 'edu-application/dist';
import { GetFullReportViewModel } from 'edu-application/dist/reports/get-full-report/get-full-report.viewmodel';
import { ChangeStudentPasswordRequest } from 'edu-application/dist/students/change-student-password/change-student-password.request'

@Injectable({
  providedIn: 'root'
})
export class StudentsService {
  private static students: ViewStudentsViewItem[] = null;
  private static studentsOnly: ViewStudentsViewItem[] = null;
  constructor(private client: HttpClient, private loginService: LoginService) { }

  async getStudents(): Promise<ViewStudentsViewItem[]> {
    if (StudentsService.students == null) {
      StudentsService.students = await this.client.get<ViewStudentsViewItem[]>(`${environment.backend_url}/students`).toPromise();
    }
    return StudentsService.students;
  }

  async getStudentsOnly(): Promise<ViewStudentsViewItem[]> {
    if (StudentsService.studentsOnly == null) {
      StudentsService.studentsOnly = await this.client.get<ViewStudentsViewItem[]>(`${environment.backend_url}/students/only`).toPromise();
    }
    return StudentsService.studentsOnly;
  }

  async getOverview(userName: string): Promise<StudentOverviewModel> {
    return this.client.get<StudentOverviewModel>(`${environment.backend_url}/students/overview/${userName}`).toPromise();
  }

  async getStudent(): Promise<ViewStudentsViewItem> {
    let userName = this.loginService.userInfo.userName
    return this.client.get<ViewStudentsViewItem>(`${environment.backend_url}/students/${userName}`).toPromise();
  }

  async getStudentDetails(username: string): Promise<ViewStudentsViewItem> {
    return this.client.get<ViewStudentsViewItem>(`${environment.backend_url}/students/details/${username}`).toPromise();
  }

  async suspend(userName: string, note: string): Promise<SuspendStudentViewModel> {
    const request = { userName, reason: note } as unknown as SuspendStudentRequest;
    return this.client.put<SuspendStudentViewModel>(`${environment.backend_url}/students/suspend`, request).toPromise();
  }

  async usnsuspend(userName: string): Promise<SuspendStudentViewModel> {
    const request = { userName } as unknown as SuspendStudentRequest;
    return this.client.put<SuspendStudentViewModel>(`${environment.backend_url}/students/unsuspend`, request).toPromise();
  }

  async transferStudent(userName: string, newGroup: string): Promise<TransferStudentViewmodel> {
    const request = { userName, groupId: newGroup } as unknown as TransferStudentRequest;
    return this.client.put<TransferStudentViewmodel>(`${environment.backend_url}/students/transfer`, request).toPromise();
  }

  async resetDevices(userName: string): Promise<void> {
    return this.client.put<void>(`${environment.backend_url}/students/reset/${userName}`, {}).toPromise();
  }

  async resetPassword(userName: string): Promise<void> {
    return this.client.put<void>(`${environment.backend_url}/students/resetpass/${userName}`, {}).toPromise();
  }

  async getSupervisorStudents(supervisor: string): Promise<ViewStudentsViewItem[]> {
    return this.client.get<ViewStudentsViewItem[]>(`${environment.backend_url}/students/supervisor/${supervisor}/students`).toPromise();
  }

  async getSupervisorReport(supervisor: string): Promise<GetFullReportViewModel> {
    return this.client.get<GetFullReportViewModel>(`${environment.backend_url}/reports/supervisor?supervisorUsername=${supervisor}`).toPromise();
  }

  async changeStudentPassword(request: ChangeStudentPasswordRequest): Promise<void> {
    return this.client.patch<void>(`${environment.backend_url}/students/change-password`, request).toPromise();
  }

  async getOnboardingReport(groupId: string): Promise<StudentsOnboardingViewmodel> {
    return this.client.get<StudentsOnboardingViewmodel>(`${environment.backend_url}/onboarding/students/report?groupId=${groupId}`).toPromise();
  }
}
